import { ReactiveVar } from '@apollo/client'

import makeVarPersisted from '~/utils/makeVarPersisted'

export const promotionVar: ReactiveVar<PromotionVar | undefined> = makeVarPersisted<PromotionVar | undefined>(
  undefined,
  'promotion',
)
